import type { ComponentConfig } from '@measured/puck';
import DOMPurify from 'dompurify';
import { Container } from '../layout/Container';

export interface RichTextProps {
  html: string;
  width?: 'narrow' | 'default';
}

export function RichText({ html, width = 'default' }: RichTextProps) {
  const sanitized = typeof window === 'undefined' ? html : DOMPurify.sanitize(html);
  return (
    <section className="bg-white py-12">
      <Container size={width === 'narrow' ? 'narrow' : 'default'}>
        <article
          className="prose prose-stone max-w-prose [&_a]:text-brand-700 [&_a:hover]:underline [&_h2]:font-display [&_h2]:tracking-tightish"
          dangerouslySetInnerHTML={{ __html: sanitized }}
        />
      </Container>
    </section>
  );
}

export const RichTextConfig: ComponentConfig<RichTextProps> = {
  fields: {
    html: { type: 'textarea' },
    width: {
      type: 'select',
      options: [
        { label: 'Étroit', value: 'narrow' },
        { label: 'Standard', value: 'default' },
      ],
    },
  },
  defaultProps: { html: '<p>Contenu éditorial</p>', width: 'default' },
  render: RichText,
};
